import { apiRequest } from '@/core';
import { type FetchEventMatchScorePayload } from '@/slices/events/types';
import { type EventMatchScore } from '@/types';

export const fetchEventMatchScoreRequest = async ({
  eventId,
}: FetchEventMatchScorePayload) =>
  apiRequest<EventMatchScore | null>({
    endpoint: `api/events/${eventId}/match-score`,
  });
